enum LOCK_VENDORS {
  keynest = 'KEYNEST',
  keylessDubai = 'KEYLESS_DUBAI',
  saltoV2 = 'SALTO_V2',
  saltoKSBeta = 'SALTO_KS_BETA',
}

enum LOCK_ACCESS_TYPES {
  private = 'PRIVATE',
  common = 'COMMON',
}

enum LOCK_OPENING_TYPES {
  CODE_AND_LINK = 'CODE_AND_LINK',
  CODE = 'CODE',
  LINK = 'LINK',
}

enum INCOMPLETE_CONDITIONS {
  afterAllPaymentsComplete = 'is_smart_lock_email_after_all_payments_complete',
  afterAllGuestsPassedBiomatchEnabled = 'is_smart_lock_email_after_all_guests_passed_biomatch_enabled',
  afterLeadGuestPassedBiomatchEnabled = 'is_smart_lock_email_after_lead_guest_passed_biomatch_enabled',
  afterLeadGuestRegisteredEnabled = 'is_smart_lock_email_after_lead_guest_registered_enabled',
  allPaymentAndAllGuestsRegistered = 'is_smart_lock_email_all_payment_and_all_guests_registered',
  allPaymentAndAllGuestsIdentified = 'is_smart_lock_email_all_payment_and_all_guests_identified',
  allPaymentAndLeadGuestsIdentified = 'is_smart_lock_email_all_payment_and_lead_guests_identified',
  afterAllGuestsRegisteredEnabled = 'is_smart_lock_email_after_all_guests_registered_enabled',
  onCheckInDayEnabled = 'is_smart_lock_email_on_check_in_day_enabled',
}

enum ACCESS_TIME_STATUS {
  default = 'DEFAULT',
  disabled = 'DISABLED',
  custom = 'CUSTOM',
}

export {
  LOCK_VENDORS,
  LOCK_ACCESS_TYPES,
  INCOMPLETE_CONDITIONS,
  LOCK_OPENING_TYPES,
  ACCESS_TIME_STATUS,
};
